import { gql } from 'graphql-tag'
import { fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'
import queryNews from '../../../core/data-layer/news/query-news'
// NOTE: queryNews is using fragmentModuleMedia

export default gql`
    ${fragmentModuleMedia}
    query($startDate: DateTime!, $endDate: DateTime!, $locale: String!, $preview: Boolean!) {
        news: pagePressAndMediaDetailCollection(where: { slug_exists: true, hiddenInHomePage_not: true, date_gt: $startDate, date_lt: $endDate } order: date_DESC, limit: 50, locale: $locale, preview: $preview) {
            items {
                defaultLocaleRouteDisabled
                ...${queryNews}
            }
        }
    }
`
